interface MobileClaimOneYearPopupOptions {
   isMobileViewport: boolean;
   isLoggedIn: boolean;
   isFirstTab: boolean;
   hasNavigatedSinceInitialOpen: boolean;
   popupAlreadyShown: boolean;
   url: string;
}

const excludedRouteFragments = [
   '/authentication',
   '/login',
   '/signin',
   '/signup',
   '/register',
];

export function isMobileClaimOneYearPopupExcludedRoute(url: string): boolean {
   const path = (url || '/').split(/[?#]/)[0].toLowerCase();
   return excludedRouteFragments.some((route) => path.includes(route));
}

export function shouldScheduleMobileClaimOneYearPopup(
   _options: MobileClaimOneYearPopupOptions
): boolean {
   return false;
}
